const Icons = {
    MM_Logo_Icon_white: require("../../assets/images/MM_Logo_Icon_white-01.png"),
    calendar: require("../../assets/images/calendar.png"),
    user: require("../../assets/images/user.png"),
    GlenMark: require("../../assets/images/Glenmark.png"),
    searchNormal: require("../../assets/images/searchNormal.png"),
};
export default Icons;
